module.exports = __webpack_public_path__ + "static/media/Confusion.f1bf9cae.jpg";